import { IPOAvatar } from '@hylaa-npm/ipod';
import { BASEURL } from '@/apis';

import { PAvatarNameWrap } from './style';

interface IPerProps {
	name_EN?: string;
	name_ZH?: string;
	avatar?: string;
	id: string;
	phoneNum: string;
	size?: number;
	shape?: 'circle' | 'square';
}
const PAvatarName = ({ name_EN = '', name_ZH = '', id = '', avatar, phoneNum }: IPerProps) => {
	return (
		<PAvatarNameWrap>
			<IPOAvatar
				size={26}
				info={{
					avatar,
					name: name_EN,
					id: id,
					name2: name_ZH,
					mobile: phoneNum,
					baseUrl: BASEURL,
				}}
			/>
			<span className="major-name">{name_ZH ? name_ZH : name_EN ? name_EN : phoneNum}</span>
			{name_ZH && name_EN && <span className="infior-name">({name_EN})</span>}
		</PAvatarNameWrap>
	);
};

export default PAvatarName;
